$(document).ready(function() {

    // get cookie gridMode
    window.gridMode = $.cookie('gridMode') ?? 'grid';

    handeGridModes(window.gridMode);

    $('#mode-slider').on('click', function() {
        event.preventDefault();
        handeGridModes($(this).data('value'));
        $.cookie('gridMode', 'slider', { expires: 7 });
    });

    $('#mode-grid').on('click', function() {
        event.preventDefault();
        handeGridModes($(this).data('value'));
        $.cookie('gridMode', 'grid', { expires: 7 });
    });

    var target = document.querySelector('#ProductGridContainer');
    target.addEventListener('ProductGridReload', function () {
        handeGridModes(window.gridMode);
    });

    function handeGridModes(gridMode){
        window.gridMode = gridMode;
        // remove active class from all modes
        $('.modes-mode').removeClass('active');
        $('.product-mode-content').removeClass('active');
        $('#mode-' + gridMode).addClass('active');
        $('.product-' + gridMode + '-content').addClass('active');
    }
});